import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactEcharts from 'echarts-for-react';
import { Col, DatePicker, Row, Select, Spin, } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as channelController from '../../../../../../services/api/channel';
import * as customerController from '../../../../../../services/api/customer';
import { leadTypeOptions, leadSourceOptions, leadStatusOptions } from '../../../../../../utils/options';
import getBetweenDates from '../../../../../../utils/getBetweenDates';

const { RangePicker } = DatePicker;
const { Option } = Select;

export class CustomerInsight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customer: {},
            channels: [],
            selectedChannels: [],
            selectedDateRanges: [moment().subtract(7, 'days'), moment()],
            selectedLeadSource: undefined,
            selectedLeadType: undefined,
            selectedLeadStatus: undefined,
            overallDistribution: {
                numberOfEnrolledLead: 0,
                numberOfLead: 0,
            },
            totalDistribution: {
                numberOfEnrolledLead: 0,
                numberOfLead: 0,
            },
            leadDistribution: [],
            enrolledLeadDistribution: [],
            isLoading: false
        }
    }

    fetchCustomer() {
        const { match } = this.props;
        const customerId = match.params.customerId;

        this.setState({ isLoading: true });

        customerController.getCustomer(customerId)
            .then((res) => res.json())
            .then((json) => this.setState({ customer: json, isLoading: false }))
    }

    fetchChannels() {
        this.setState({ isLoading: true });

        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json, isLoading: false }))
    }

    fetchOverallDistribution() {
        const { match } = this.props;
        const { selectedDateRanges, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        const customerId = match.params.customerId;
        this.setState({ isLoading: true });

        customerController.getOverallDistribution({
                customer_id: customerId,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                let newState = { isLoading: false };

                if (json.length !== 0) {
                    newState.overallDistribution = {
                        numberOfEnrolledLead: json[0].number_of_enrolled_lead,
                        numberOfLead: json[0].number_of_lead
                    }
                } else {
                    newState.overallDistribution = {
                        numberOfEnrolledLead: 0,
                        numberOfLead: 0
                    }
                }

                this.setState(newState);
            })
    }

    fetchTotalDistribution() {
        const { match } = this.props;
        const customerId = match.params.customerId;
        this.setState({ isLoading: true });

        customerController.getOverallDistribution({
                customer_id: customerId
            })
            .then((res) => res.json())
            .then((json) => {
                let newState = { isLoading: false };

                if (json.length !== 0) {
                    newState.totalDistribution = {
                        numberOfEnrolledLead: json[0].number_of_enrolled_lead,
                        numberOfLead: json[0].number_of_lead
                    }
                }

                this.setState(newState);
            })
    }

    fetchLeadDistribution() {
        const { match } = this.props;
        const { selectedChannels, selectedDateRanges, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        const customerId = match.params.customerId;
        this.setState({ isLoading: true });

        customerController.getLeadDistribution({
                customer_id: customerId,
                channel_ids: selectedChannels,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                const dates = getBetweenDates(selectedDateRanges[0], selectedDateRanges[1]);
                let results = _.fill(Array(dates.length), 0);

                _.forEach(json, (record) => {
                    const targetIndex = _.indexOf(dates, moment(record.timestamp).format('DD/MM/YYYY'));
                    if (targetIndex !== -1) {
                        results[targetIndex] = record.number_of_lead;
                    }
                })

                this.setState({ leadDistribution: results, isLoading: false });
            })
    }

    fetchEnrolledLeadDistribution() {
        const { match } = this.props;
        const { selectedChannels, selectedDateRanges, selectedLeadSource, selectedLeadType, selectedLeadStatus } = this.state;
        const customerId = match.params.customerId;
        this.setState({ isLoading: true });

        customerController.getEnrollmentDistribution({
                customer_id: customerId,
                channel_ids: selectedChannels,
                lead_source: selectedLeadSource,
                lead_type: selectedLeadType,
                lead_status: selectedLeadStatus,
                since: selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                const dates = getBetweenDates(selectedDateRanges[0], selectedDateRanges[1]);
                let results = _.fill(Array(dates.length), 0);

                _.forEach(json, (record) => {
                    const targetIndex = _.indexOf(dates, moment(record.timestamp).format('DD/MM/YYYY'));
                    if (targetIndex !== -1) {
                        results[targetIndex] = record.number_of_enrolled_lead;
                    }
                })

                this.setState({ enrolledLeadDistribution: results, isLoading: false });
            })
    }

    getCustomerChartOption() {
        const { selectedDateRanges, leadDistribution, enrolledLeadDistribution } = this.state;

        const option = {
            tooltip: {
                trigger: 'axis',
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        title: 'Save as image'
                    }
                }
            },
            xAxis: [{
                type: 'category',
                data: getBetweenDates(selectedDateRanges[0], selectedDateRanges[1])
            }],
            yAxis: {
                type: 'value',
                axisPointer: {
                    snap: true
                },
                interval: 1
            },
            legend: {
                data: ['Lead', 'Enrolled Lead']
            },
            series: [{
                name: 'Lead',
                type: 'line',
                data: leadDistribution
            }, {
                name: 'Enrolled Lead',
                type: 'line',
                data: enrolledLeadDistribution
            }]
        };

        return option;
    }

    componentDidMount() {
        this.fetchCustomer();
        this.fetchChannels();
        this.fetchOverallDistribution();
        this.fetchTotalDistribution();
        this.fetchLeadDistribution();
        this.fetchEnrolledLeadDistribution();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            channels,
            selectedChannels,
            selectedDateRanges,
            selectedLeadSource,
            selectedLeadType,
            selectedLeadStatus
        } = this.state;

        if ((!_.isEqual(channels, prevState.channels) && channels.length !== 0) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            !_.isEqual(selectedDateRanges, prevState.selectedDateRanges) ||
            selectedLeadSource !== prevState.selectedLeadSource ||
            selectedLeadType !== prevState.selectedLeadType ||
            selectedLeadStatus !== prevState.selectedLeadStatus) {
            this.fetchLeadDistribution();
            this.fetchEnrolledLeadDistribution();
        }

        if (!_.isEqual(selectedDateRanges, prevState.selectedDateRanges) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            selectedLeadSource !== prevState.selectedLeadSource ||
            selectedLeadType !== prevState.selectedLeadType ||
            selectedLeadStatus !== prevState.selectedLeadStatus) {
            this.fetchOverallDistribution();
        }
    }

    render() {
        const {
            customer,
            channels,
            selectedChannels,
            selectedDateRanges,
            selectedLeadSource,
            selectedLeadType,
            selectedLeadStatus,
            overallDistribution,
            totalDistribution,
            isLoading
        } = this.state;

        const channelOptions = _.map(channels, (channel) => <Option key={channel.id} value={channel.id}>{channel.name}</Option>);
        const leadSourceOptionComponents = _.map(leadSourceOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadTypeOptionComponents = _.map(leadTypeOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadStatusOptionComponents = _.map(leadStatusOptions, (item) => <Option key={item} value={item}>{item}</Option>);

        return (
            <Spin spinning={isLoading}>
                <div className="InsightSection">
                    <Row gutter={16} className="option-bar">
                        <Col span={24}>
                            <div className="query-option">
                                <label>Channel(s): </label>
                                <Select
                                    mode="multiple"
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    value={selectedChannels}
                                    onChange={(value) => this.setState({ selectedChannels: value} )}
                                >
                                    {channelOptions}
                                </Select>
                            </div>
                            {" "}
                            <div className="query-option">
                                <label>Select Range: </label>
                                <RangePicker
                                    value={selectedDateRanges}
                                    onChange={(dates, dateStrings) => this.setState({ selectedDateRanges: dates })}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16} className="option-bar">
                        <Col span={24}>
                            <div className="query-option">
                                <label>Lead Source: </label>
                                <Select
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    vallue={selectedLeadSource}
                                    onChange={(value) => this.setState({ selectedLeadSource: value })}
                                >
                                    {leadSourceOptionComponents}
                                </Select>
                            </div>
                            {" "}
                            <div className="query-option">
                                <label>Lead Type: </label>
                                <Select
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    vallue={selectedLeadType}
                                    onChange={(value) => this.setState({ selectedLeadType: value })}
                                >
                                    {leadTypeOptionComponents}
                                </Select>
                            </div>
                            {" "}
                            <div className="query-option">
                                <label>Lead Status: </label>
                                <Select
                                    allowClear
                                    style={{ width: 200 }}
                                    placeholder="(All)"
                                    vallue={selectedLeadStatus}
                                    onChange={(value) => this.setState({ selectedLeadStatus: value })}
                                >
                                    {leadStatusOptionComponents}
                                </Select>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} xs={24}>
                            <h3>{`Distribution within the range (${customer.name})`}</h3>
                            <p>Number of Enrolled Lead: {overallDistribution.numberOfEnrolledLead}</p>
                            <p>Number of Lead: {overallDistribution.numberOfLead}</p>
                        </Col>
                        <Col lg={12} xs={24}>
                            <h3>{`Total as of today (${customer.name})`}</h3>
                            <p>Number of Enrolled Lead: {totalDistribution.numberOfEnrolledLead}</p>
                            <p>Number of Lead: {totalDistribution.numberOfLead}</p>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <h3>Enrollment & Lead distribution over time</h3>
                            <ReactEcharts
                                style={{ height: '500px'}}
                                notMerge
                                theme={'informatics'}
                                option={this.getCustomerChartOption()}
                            />
                        </Col>
                    </Row>
                </div>
            </Spin>
        );
    }
}

export default withRouter(CustomerInsight);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerManagementPage/components/CustomerInsight/CustomerInsight.js